/* 
  Garante estrutura mínima das relações do "processo" para evitar
  TypeError em telas que acessam propriedades aninhadas (ex: categoria_processo.descricao)
*/
const defaultPessoa = () => ({
  id: null,
  nr_cpfcnpj: "",
  nm_pessoa: "",
  telefones: [],
});

const defaultRelacao = (extra = {}) => ({ id: null, descricao: "", ...extra });

function normalizaPessoa(pessoa) {
  return {
    ...defaultPessoa(),
    ...pessoa,
    telefones: (pessoa && pessoa.telefones) || [],
  };
}

export function normalizeProcesso(processo = {}) {
  return {
    ...processo,
    categoria_processo: processo.categoria_processo || defaultRelacao(),
    status_processo:
      processo.status_processo || defaultRelacao({ ds_situacao: "" }),
    tipo_processo: processo.tipo_processo || defaultRelacao(),
    acionado: {
      id: null,
      ...processo.acionado,
      pessoa: normalizaPessoa(processo.acionado && processo.acionado.pessoa),
    },
    cliente: {
      id: null,
      ...processo.cliente,
      pessoa: normalizaPessoa(processo.cliente && processo.cliente.pessoa),
    },
  };
}

export function normalizeProcessos(lista = []) {
  return (lista || []).map(normalizeProcesso);
}



// WEBPACK FOOTER //
// ./src/utils/normalizeProcesso.js